import { Component, ViewEncapsulation, input } from '@angular/core';

/**
 * Header and footer of an exported grid page (#199):
 *
 *   <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
 *     <app-pdf-page title="Verkäufe" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
 *   </ng-template>
 *
 * Ten grids carried this template with the classes from Kendo's example (`page-template`,
 * `header`, `footer`) — and none of the example's CSS, so header and footer were unpositioned
 * text. The styles live here, once. Kendo renders the template into its export container and
 * draws it from computed styles, which is why component-scoped CSS works for it.
 */
@Component({
  selector: 'app-pdf-page',
  // Unencapsulated on purpose: Kendo renders the page template to an HTML string and places it
  // on each page of the drawing, where Angular's scoping attributes no longer match. The class
  // names carry their own prefix instead.
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="pdf-page">
      <div class="pdf-page__header">{{ title() }}</div>
      <div class="pdf-page__footer" i18n>Seite {{ pageNum() }} von {{ totalPages() }}</div>
    </div>
  `,
  styles: [
    `
      .pdf-page {
        position: absolute;
        inset: 0;
        font-family: 'DejaVu Sans', sans-serif;
      }
      .pdf-page__header {
        position: absolute;
        top: 30px;
        left: 30px;
        right: 30px;
        padding-bottom: 4px;
        border-bottom: 1px solid #888;
        font-size: 18px;
      }
      .pdf-page__footer {
        position: absolute;
        bottom: 30px;
        left: 30px;
        right: 30px;
        padding-top: 4px;
        border-top: 1px solid #888;
        text-align: center;
        font-size: 12px;
      }
    `,
  ],
})
export class PdfPageComponent {
  readonly title = input<string>();
  readonly pageNum = input<number>();
  readonly totalPages = input<number>();
}
